module.exports = __webpack_public_path__ + "img/sharpsmart.9edf98f9.png";